import {connect} from 'react-redux';
import {setNotificationAction} from '@pluto/notification/Redux/NotificationActions';
import FormContainer from './FormContainer';
import {EditFormState, StoreState} from '../Redux/Types';
import {loadAction, loadDevicesAction, updateAction, cleanAction} from '../Redux/Actions';

export const mapState = (state: StoreState): EditFormState => {
    return {
        item: state.appName.item,
        isLoading: state.appName.isLoading,
        devices: state.devices.rows,
        errors: state.appName.errors,
        saveCompleted: state.appName.saveCompleted,
    };
};

export const mapDispatch = {
    load: loadAction,
    update: updateAction,
    loadDevices: loadDevicesAction,
    clean: cleanAction,
    setNotification: setNotificationAction,
};

export default connect(mapState, mapDispatch as any)(FormContainer);
